import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingSpinner } from '@/components/LoadingSpinner';

export const RequireAuth = ({ children }) => {
  const { user, loading, isAuthenticated, accessoComeCondomino } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" text="Caricamento..." />
      </div>
    );
  }

  // Check both user and isAuthenticated for robustness
  if (!user && !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Condomino con la password provvisoria: finche' non la sceglie lui, puo' vedere solo la pagina per cambiarla
  // (non vale per l'amministratore che sta entrando come lui)
  if (user?.force_password_change && !accessoComeCondomino && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return children;
};